import BaseService from "core/framework/BaseService";
import env from "environment";

class ProviderRegistrationRequestServicce extends BaseService {
  constructor() {
    super();

    this.baseUrl = env.baseUrl + "/public/providers";
  }

  async insert({ instance }) {
    if (!instance) {
      console.error("Missing parameter: instance");
      throw Error("Missing parameter: instance");
    }

    console.log("Inserting ", instance);

    return await this.post({
      url: this.baseUrl,
      data: instance
    });
  }
}

const service = new ProviderRegistrationRequestServicce();

export default service;
